import { render, staticRenderFns } from "./CharactersLeft.vue?vue&type=template&id=9f613d66&scoped=true&"
import script from "./CharactersLeft.vue?vue&type=script&lang=js&"
export * from "./CharactersLeft.vue?vue&type=script&lang=js&"
import style0 from "./CharactersLeft.vue?vue&type=style&index=0&id=9f613d66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f613d66",
  null
  
)

export default component.exports